module.exports = new __parcel__URL__("FieldIllustration.a260a224.svg").toString();